import { URLS , Keywords } from '../constants/appConstants';

const NavigationUtil = {};

NavigationUtil.getUrlParam = (key) => {
  let urlParams;
  if(global.window){
    urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
  }
  else
    return null;
};

NavigationUtil.getAnchorParam = (key) => {
  
  if(global.window)
  {
    let anchor = window.location.hash.replace('#', '');
    let params = new URLSearchParams(anchor);
    return params.get(key);
  }
  else return null;
};

NavigationUtil.setUrlParam = (key,value) => {
  if(global.window){
    let urlParams = new URLSearchParams(window.location.search);
    urlParams.set(key,value);
    window.location.search = (urlParams).toString();
  }
};

NavigationUtil.encodeRedirect = (redirect) => {
  let append;
  if(localStorage.getItem("loginRAF")) {
     append = '';
  } else if(global.window) {
     append = encodeURIComponent(window.location.href);
  }
  else 
    append = false;

  return append ? redirect + '?ReturnUrl=' + append : redirect;
};


NavigationUtil.decodeRedirect = (redirect) => {
  let rebound =  NavigationUtil.getUrlParam('ReturnUrl');
  if(rebound){
    return decodeURIComponent(rebound);
  }
  return redirect;
};

NavigationUtil.redirectToLogin = () => {
  let isLoginFromPopup = localStorage.getItem('loginPopup') !== null ? true : false;
  if (global.window && window.location.pathname.indexOf(URLS.login) > -1 || isLoginFromPopup) {
    return;
  }
  else if ((global.window && window.location.pathname.indexOf(Keywords.account) > -1) || (global.window && window.location.pathname.indexOf(Keywords.buyOnline) > -1)) {
    window.location.href = NavigationUtil.encodeRedirect(URLS.login);
  } else if(global.window) {
    window.location.href = URLS.login;
  }
};

NavigationUtil.getWord = () => {
  return global.window && window.location.pathname.split('/').reverse()[0];
};

NavigationUtil.getWordList = () => {
  return global.window && window.location.pathname.split('/');
};

NavigationUtil.replaceCDNPath = (imgPath) => {
  return imgPath.replace(process.env.NEXT_PUBLIC_CDN_IMAGE_URL, process.env.NEXT_PUBLIC_CONTENT_URL+'/');
}

NavigationUtil.getRegion = () => {
  var url=NavigationUtil.getWordList();
  var indexOfRegion = url.indexOf('local-lawn-care') + 1;
  return url[indexOfRegion].replace(/-/g, '%20');
};

export default NavigationUtil;